
<template>
  <v-container fluid dark>
    <div class="smoothtalkr-edit">
      <error-messages v-show="!bEnableEditing"
        :bSceneDoesntExist="bSceneDoesntExist"
        :bSceneIsNotOwnedByMe="bSceneIsNotOwnedByMe"
        @localStorageNotSupported="disableEditing"
        @makeCopy="makeCopy"
      ></error-messages>
      <div v-show="bEnableEditing">
        <v-toolbar
          color="grey"
        >
          <v-layout justify-space-between>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on:click="onFaces()"
                  v-on="on"
                  color="grey darken-4"
                  >
                <v-icon>person_add</v-icon>
                </v-btn>
              </template>
              <span>Add a face</span>
            </v-tooltip>
          <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :style="{visibility: ctx.defaultFile.text.length ? 'visible' : 'hidden'}"
                  color="grey darken-4"
                  v-on:click="onPlay()"
                  v-on="on"
                  >
                <v-icon>play_arrow</v-icon>
                </v-btn>
              </template>
              <span>Play (Ctrl + Enter)</span>
            </v-tooltip>
          <v-tooltip bottom v-if="user && !isRemote()">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="grey darken-4"
                  v-on:click="onPublish()"
                  v-on="on"
                  :style="{visibility: ctx.defaultFile.text.length ? 'visible' : 'hidden'}"
                  >
                <v-icon>publish</v-icon>
                </v-btn>
              </template>
              <span>Publish content online</span>
          </v-tooltip>

          </v-layout>
        </v-toolbar>

      <characters-display
        :bIsRemote="isRemote()"
        ref="characterDisplay"
        @modified="modifiedCharacters"
        @delete="deleteFaceId"
        @newPicBlobs="newPicBlobs"
      ></characters-display>

      <character-warning
        class="modaloverlay"
        v-show="showCharacterWarning"
        ref="characterWarning"
        @ok="onOKCharacterWarning"
        @cancel="onCancelCharacterWarning"
      ></character-warning>
      <div class="white--text" v-show="ctx.defaultFile.text.length==0">
        Not sure what to do?  Take a look at the <a href="#/play/VyB4gYHkoVnSX8VG6w1h">samples</a>.
      </div>

      <prism-editor
        v-model="ctx.defaultFile.text"
        language="smoothtalkr"
        :lineNumbers="true"
        emitEvents
        v-on:keydown="onKeyDown"
        class="my-editor"
        ref="prismEditor"

        >
      </prism-editor>
      <v-chip
        dark
        color="red"
        class="compile-error-class"
        ref="compileErrorRef"
        v-show="compileError">
      {{compileError}}
      </v-chip>

        <v-btn
          style="margin-top: 75px;"
          align-end
          v-on:click="onDelete()"
          color="red"
        >
        <v-icon>delete</v-icon>
        Delete
      </v-btn>
    </div>
  </div>
  </v-container>
</template>

<script>
import ErrorMessages from '@/components/ErrorMessages'
import CharactersDisplay from '@/components/CharacterPicker/CharactersDisplay'
import CharacterWarning from '@/components/CharacterPicker/CharacterWarning'
import firebase from 'firebase/app'
import {SmoothContext, SmoothFile, SmoothSyntax} from 'smooth-script'
import PrismEditor from 'vue-prism-editor'

import Prism from 'prismjs'

import '../css/prism.css'
import APNGLoader from '../apng'

export default {
  name: 'multiplechoice-edit',
  components: {
    'characters-display': CharactersDisplay,
    'character-warning': CharacterWarning,
    'prism-editor': PrismEditor,
    'error-messages': ErrorMessages
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      user: firebase.auth().currentUser,
      ctx: null,
      autoSave: true,
      isModified: false,
      errorLines: [],
      compileError: '',
      showCharacterWarning: false,
      onCharacterWarningOKFn: null,
      bEnableEditing: true,
      bSceneDoesntExist: false,
      bSceneIsNotOwnedByMe: false,
      bNewStory: false
    }
  },
  computed: {
    chats () {
      var remote = this.$store.getters['main/remotechats']
      var local = this.$store.getters['main/chats']
      return Object.assign({}, remote, local)
    },
    remoteChats () {
      return this.$store.getters['main/remotechats']
    },
    initialized () {
      return this.$store.getters['main/bInitialized']
    },
    defaultOptions () {
      return this.$store.getters['main/defaultOptions']
    }
  },
  methods: {
    makeCopy: function () {
      var newFile = new SmoothFile(this.ctx.defaultFile)
      newFile.firestore = {}
      var oldId = this.id
      this.$store.dispatch('main/createContent', (JSON.parse(JSON.stringify(newFile))))
        .then((id) => {
          this.autoSave = false
          this.$store.dispatch('main/deleteChat', oldId).then(() => {
            this.$router.push({ path: `/edit/${id}` })
            this.bEnableEditing = true
            this.bSceneIsNotOwnedByMe = false
          })
        })
    },
    getLocalSaveDelay: function () {
      return 2000
    },
    getRemoteSaveDelay: function () {
      return 30000
    },
    disableEditing: function () {
      this.bEnableEditing = false
    },
    newPicBlobs: function (args) {
      if (args.apng && args.thumb) {
        if (this.isRemote()) {
          this.saveLocal().then((chatIdData) => {
            args.chatIdData = chatIdData
            this.$store.dispatch('main/uploadNewImage', args).then((faceData) => {
              if (args.onFinished) {
                args.onFinished(faceData)
              }
            })
          })
        } else {
          APNGLoader.blobToBase64(args.apng, args.thumb, args.faceId,
            (base64Apng, base64Thumb) => {
              var idData = {id: args.faceId, apng: base64Apng, thumb: base64Thumb}
              this.$store.dispatch('main/loadLocalAPNG', idData).then(() => {
                APNGLoader.saveAPNGLocally(base64Apng, base64Thumb, args.faceId, () => {
                  if (args.onFinished) {
                    args.onFinished()
                  }
                }, () => {
                  this.showCharacterWarning = true
                  this.$refs.characterWarning.setMessage('Local storage is full and this pic can not be saved.  It will only be available during this browser session.  Free up space by deleting or publishing stories, or deleting your browser cache.')
                  this.showCharacterWarning = true
                  this.onCharacterWarningOKFn = () => {
                    this.onCharacterWarningOKFn = null
                    if (args.onFinished) {
                      args.onFinished()
                    }
                  }
                })
              })
            },
            () => {
              throw new Error('Failed to convert image blob to base64')
            }
          )
        }
      } else {
        console.warn('Invalid args to newPicBlobs')
      }
    },
    onOKCharacterWarning: function () {
      this.showCharacterWarning = false
      if (this.onCharacterWarningOKFn) {
        this.onCharacterWarningOKFn()
      }
    },
    onCancelCharacterWarning: function () {
      this.showCharacterWarning = false
    },
    onFaces: function () {
      this.$refs.characterDisplay.onAdd()
    },
    isRemote () {
      return this.id in this.remoteChats
    },
    onCompile: function () {
      var compiledChatContext = new SmoothContext(this.ctx.defaultFile.getMinimizedJson())
      var lineNumbers = []
      var errors = []
      if (compiledChatContext.getLineErrors(compiledChatContext.getLines(), lineNumbers, errors)) {
        this.setCompileErrorLines(lineNumbers, errors)
        return false
      }
      return true
    },
    markModified: function () {
      if (!this.isModified) {
        this.isModified = true
        setTimeout(() => {
          if (this.isModified) {
            this.saveLocal()
            setTimeout(() => {
              this.saveServer()
            }, this.getRemoteSaveDelay())
          }
        }, this.getLocalSaveDelay())
      }
    },
    onKeyDown: function (evt) {
      this.markModified()
      // override Enter key implementation to do custom indent
      if (evt.keyCode === 13) {
        if (evt.shiftKey) {
          // Holding shift & enter will compile
          // Save
          this.saveLocal().then((chatIdData) => {
            this.onCompile()
          })

          setTimeout(() => {
            // delete the new-line that will get inserted by the enter
            document.execCommand('delete', false)
          }, 0)
          return
        }
        // Enter Key
        // const { start: cursorPos } = selectionRange(this.$refs.pre);
        // const indentation = getIndent(this.$refs.pre.innerText, cursorPos);
        // https://stackoverflow.com/questions/35585421
        // add a space and remove it. it works :/
        var positionPriorToEnter = this.$refs.prismEditor.selection.start
        var lineStart = this.ctx.defaultFile.text.lastIndexOf('\n', positionPriorToEnter - 1) + 1
        var line = this.ctx.defaultFile.text.substring(lineStart, positionPriorToEnter).trim()

        var additionalIndent = ''
        if (line.startsWith('#') || line.match(/\*\b(?:if|else|choice)\b/)) {
          additionalIndent += '  '
        }
        // using setTimeout so our spaces are added after the new line is added by the vue-prism-editor
        // it appears to be too late to call evt.preventDefault() or stopPropagation()
        setTimeout(() => {
          if (additionalIndent.length) {
            // Copying how vue-prism-editor fixes indent
            document.execCommand('insertHTML', false, ' ' + additionalIndent)
            document.execCommand('delete', false)
          }
        }, 0)
      }
    },
    setCompileErrorLines (errorLines, errors) {
      this.clearCompileErrorLines()
      this.errorLines = errorLines
      var el = this.$refs.prismEditor.$el
      if (errorLines.length !== errors.length) {
        throw new Error('Mismatched arrays in compile errors')
      }
      var compileErrorElement = this.$refs.compileErrorRef.$el
      for (var i = 0; i < this.errorLines.length; ++i) {
        ((i) => {
          var li = this.errorLines[i]
          var nodes = el.children[0].children
          if (li < nodes.length) {
            nodes[li].setAttribute('class', 'compileError')
            nodes[li].onmouseover = (evt) => {
              compileErrorElement.style.left = evt.pageX + 10 + 'px'
              compileErrorElement.style.top = evt.pageY - 30 + 'px'
              this.compileError = errors[i]
            }
            nodes[li].onmouseleave = (evt) => {
              this.compileError = ''
            }
          }
        })(i)
      }
      // Scroll the first error into view
      if (this.errorLines.length) {
        var errorLineElement = el.children[0].children[this.errorLines[0]]
        if (errorLineElement) {
          errorLineElement.scrollIntoView()
        } else {
          throw new Error(' no errorLineElement! ' + this.errorLines[0])
        }
      }
    },
    clearCompileErrorLines () {
      if (this.errorLines.length) {
        var el = this.$refs.prismEditor.$el
        for (var i = 0; i < this.errorLines.length; ++i) {
          var li = this.errorLines[i] + 1
          var nodes = el.children[0].children
          if (li < nodes.length) {
            nodes[li].classList.remove('compileError')
            nodes.onmouseover = null
          }
        }
        this.errorLines = []
      }
    },
    modifiedCharacters: function (preamble) {
      this.ctx.defaultFile.preamble = preamble
      this.ctx.defaultFile.parseFaces()
      this.markModified()
    },
    checkFormat: function (q) {
      return true
    },
    onInitialized: function () {
      this.$store.dispatch('main/setCurrentChatId', this.id).then((data) => {
        if (data) {
          if (data.firestore && data.firestore.owner && (!this.user || (this.user && this.user.uid !== data.firestore.owner))) {
            this.bEnableEditing = false
            this.bSceneIsNotOwnedByMe = true
          }
          if (!data.text || !data.text.length) {
            this.bNewStory = true
          }
          this.ctx = new SmoothContext(JSON.parse(JSON.stringify(data)))

          var preambleContext = new SmoothContext(JSON.parse(JSON.stringify({preamble: data.preamble})))
          // Trick the preamble context not to download create_face content.
          preambleContext.currentFaceId = 'NO_FACE_ID'
          preambleContext.play().then(() => {
            this.$refs.characterDisplay.updateFromContext(preambleContext)
          })
        } else {
          this.bEnableEditing = false
          this.bSceneDoesntExist = true
        }
      }).catch((error) => {
        console.warn(error)
      })
    },
    saveLocal: function () {
      if (!this.autoSave) {
        return
      }
      this.isModified = false
      var minimizedData = this.ctx.defaultFile.getUpdatedJson()
      if (this.ctx.defaultFile.text.length || this.ctx.defaultFile.preamble.length) {
        return this.$store.dispatch('main/updateChatLocal', {chatId: this.id, data: minimizedData})
          .then((chatIdData) => {
            var ctx = new SmoothContext(JSON.parse(JSON.stringify(chatIdData.data)))
            this.ctx.defaultFile = ctx.defaultFile
            return chatIdData
          })
      }
      return {id: this.id, data: new SmoothFile()}
    },
    saveServer: function () {
      if (!this.autoSave) {
        return
      }
      this.isModified = false
      var minimizedData = this.ctx.defaultFile.getUpdatedJson()
      return this.$store.dispatch('main/updateChatLocalAndRemote', {chatId: this.id, data: minimizedData})
    },
    onPublish: function () {
      this.saveLocal().then((chatIdData) => {
        var publishFn = () => {
          // Generate first to create a name if it doesn't exist
          if (!(this.id in this.remoteChats)) {
            this.$store.dispatch('main/createChatServer', chatIdData).then((chatIdData) => {
              this.autoSave = false
              this.$router.push({ path: '/edit/' + chatIdData.chatId })
              this.ctx = new SmoothContext(chatIdData.data)
            })
          }
          this.onCharacterWarningOKFn = null
        }

        this.$store.dispatch('main/getPotentialUploadedFaces', chatIdData).then((faceIdsToUpload) => {
          if (faceIdsToUpload.length) {
            this.onCharacterWarningOKFn = publishFn
            this.$refs.characterWarning.setFaceIds(faceIdsToUpload)
            this.$refs.characterWarning.setMessage('Publishing will upload the following faces to our server so other people can play your content.')
            this.showCharacterWarning = true
          } else {
            publishFn()
          }
        })
      })
    },
    onPlay: function () {
      var path = '/play/' + this.id
      this.saveServer().then((chatIdData) => {
        if (this.onCompile()) {
          this.$router.push({ path: path })
        }
      })
    },
    deleteFaceId: function (faceId) {
      this.$store.dispatch('main/getPotentialDeletedFaces', {chatId: this.id, data: this.ctx.defaultFile.getUpdatedJson()}).then((faceIdsToDelete) => {
        if (faceIdsToDelete.length && faceId === faceIdsToDelete[0]) {
          this.$store.dispatch('main/deleteFace', faceId)
        }
      })
    },
    onDelete: function () {
      this.$store.dispatch('main/getPotentialDeletedFaces', {chatId: this.id, data: this.ctx.defaultFile.getUpdatedJson()}).then((faceIdsToDelete) => {
        var deleteFn = () => {
          this.autoSave = false
          this.onCharacterWarningOKFn = null
          var promises = []
          for (var i = 0; i < faceIdsToDelete.length; ++i) {
            promises.push(this.$store.dispatch('main/deleteFace', faceIdsToDelete[i]))
          }
          Promise.all(promises).then(() => {
            this.autoSave = false
            this.$store.dispatch('main/deleteChat', this.id).then(() => {
              this.$router.push({path: '/'})
            })
          })
        }

        this.onCharacterWarningOKFn = deleteFn
        this.$refs.characterWarning.setFaceIds(faceIdsToDelete)
        if (faceIdsToDelete.length) {
          if (this.ctx.defaultFile.firestore.owner) {
            console.log(this.ctx.defaultFile.firestore.owner)
            this.$refs.characterWarning.setMessage('Deleting this content will permemently delete the following faces from our server. Continue?')
          } else {
            // We know these are local faces because this is an unpublished scene that
            // can use remote faces, but we don't look at unpublished scenes when deleting remote faces.
            this.$refs.characterWarning.setMessage('Deleting this content will permemently delete the following faces from the local cache. Continue?')
          }
        } else {
          this.$refs.characterWarning.setMessage('Are you sure?')
        }
        this.showCharacterWarning = true
      })
    }
  },
  created: function () {
    if (!this.ctx) {
      this.ctx = new SmoothContext()
    }
  },
  mounted: function () {
    if (this.initialized) {
      this.onInitialized()
    }
    // Add our syntax highlighting to Prism
    (function (Prism) {
      var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/

      Prism.languages.smoothtalkr = Prism.languages.html
      Prism.languages.smoothtalkr.comment = SmoothSyntax.commentPrism
      Prism.languages.smoothtalkr.smoothfunction = {
        pattern: SmoothSyntax.functionLinePrism,
        inside: {
          'important': SmoothSyntax.escapedExpressionPrism,
          'function': SmoothSyntax.functionNameHighlightPrism,
          'string': string,
          'keyword': /true|false/,
          'variable': SmoothSyntax.variableName,
          'number': /\d/
        }
      }
      Prism.languages.smoothtalkr.important = SmoothSyntax.escapedExpressionPrism
    }(Prism))
  },
  beforeDestroy: function () {
    if (this.ctx.defaultFile.text.length) {
      this.saveServer()
    } else {
      if (this.bNewStory) {
        // Delete empty chat if this started off empty.  Click (+) to create an empty chat
        // Beware, some errors seem to cause the text to be empty so users can loose work if we don't check the
        // the bNewStory variable.
        this.$store.dispatch('main/deleteChat', this.id)
      }
    }
  },
  watch: {
    initialized: function (newVal, oldVal) {
      firebase.auth().onAuthStateChanged((changeduser) => {
        this.user = changeduser
      })

      if (newVal && !oldVal) {
        this.onInitialized()
      }
    }
  }
}
</script>

<style>
.compile-error-class {
  position:absolute;
  z-index: 100;
}
.language-smoothtalkr {
  width: 100%;
}
.compileError {
     background-color: red;
 }
.my-editor {
  /*
  prevent safari from showing a scrollbar momentarily when deleting a line
  */
    overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SmoothEdit.vue